module.exports = __webpack_public_path__ + "img/AirBolt_Enterprise_Logo.60afbfa3.png";